// extracted by mini-css-extract-plugin
export default {"wrapper":"NgxlqXU0XfoBjL0mnKgp","container":"PL16njDTWPCdhJeaQUkO","headline":"lPQTBAD2AkA75_wkqBJ1","links_wrapper":"a4VKga5ep8HjT9BwP0pB"};